import AxiosProvider from '@/app/utils/api/axios-provider';
import type { FeatureFlag } from '@/app/shared/types/feature-flag.type';

export async function fetchFeatureFlags(): Promise<
  Partial<Record<FeatureFlag, boolean>>
> {
  const { data } = await AxiosProvider.adminApiClient.get('/features');
  return data.data;
}
